<template>
<span>
    <input
            ref="uploader"
            class="d-none"
            type="file" capture="camera"
            accept="image/*"
            @change="submitFile($event)"
            multiple
            >
    <v-row v-if="isIconUploader()">
        <v-col cols="12">
            <v-tooltip bottom >
                <template v-slot:activator="{ on, attrs }"> 
                    <v-btn
                    :loading="isSelecting"
                    v-bind="attrs"
                    v-on="on"
                    icon
                    color="grey lighten-4"
                    height="110"
                    width="110"
                    @click="onUploaderClick"
                    >
                        <v-icon
                        x-large
                        color="grey"
                        class="pa-1"
                        style="font-size: 80px;"
                        >{{prependIcon}}</v-icon>
                    </v-btn>
                </template>
                    <span>{{$t("uploader.addImage")}}</span>
            </v-tooltip>
        </v-col>
    </v-row>
    <v-btn
        :loading="isSelecting"
        color="primary"
        v-if="!isIconUploader()"
        @click="onUploaderClick"
        class="ma-2"
        outlined
        >
        <v-icon
        class="mx-2"
        dark
        >
        mdi-image-multiple
        </v-icon>        
        {{$t("uploader.uploadImageAlbum")}}
    </v-btn>
    <v-snackbar
        style="z-index:100002"
        v-model="postError"
        :top="true"
        class="fixNotchMarginTop"
        :timeout="2000"
        color="error"
      >
        {{errorMessage}}
        <template v-slot:action="{ attrs }">
          <v-btn color="black" text v-bind="attrs" @click="postError = null">{{$t('HISTORY_CLOSE')}}</v-btn>
        </template>
      </v-snackbar>
</span>
</template>

<script>
import pictureManager from "../../common/PictureManager";
import api from "../../../api/flexiapp";

  export default {
    name: 'IconPictureUploaderStepByStep', 
    props: ['prependIcon','workorderId','lineId','assembleStepId'],
    data(){
        return {  
             show: false,
             files: [],
             loading: false,
             callback: null,
             selectedSlot: 0,
             isSelecting: false,
             errorMessage: null,
             postError: false,
        }

    },  
    updated: function() {
        // fix for v-file-input not triggering properly

        setTimeout(() => {
            let inputs = document.querySelectorAll('.v-file-input input');
            [...inputs].forEach((input) => {
                input.remove()
            }) 
        }, 1000);       
    },
    computed: {
    },
    methods: {
        close()
        {
            this.show=false
        },
        isIconUploader(){
            return this.prependIcon;
        },
        selectPicture(url)
        {
            if (this.callback)
                this.callback(url);

            this.close();
        },
          submitFile(event){
            this.files = event.target.files;

            this.loading=true;
            this.errorMessage= null;
            this.postError= false;

            const files = this.files;

            for (var index = 0; index < files.length; index++) {            
                const reader = new FileReader();
                const me = this;
                let imageFile = files[index];

                //obtenemos base64 imagen
                reader.onload = (e) => {
                    const maxSize = 400;
                    var img = new Image();

                    img.onload = function() {
                        const canvas = document.createElement('canvas');
                        canvas.style.position="absolute";
                        canvas.style.left="-10000px";

                        let { width, height } = imageFile;

                        width = width ? width : 500;
                        height = height ? height: 500;

                        if (width > height) {
                            if (width > maxSize) {
                                height *= maxSize / width;
                                width = maxSize;
                            }
                        } else if (height > maxSize) {
                            width *= maxSize / height;
                            height = maxSize;
                        }

                        const ctx = canvas.getContext("2d");

                        window.$vue.$el.appendChild(canvas);

                        canvas.width = width ? width : 500;
                        canvas.height = height ? height: 500;

                        ctx.drawImage(img, 0, 0, width, height);

                        window.$vue.$el.removeChild(canvas);

                        var dataurl = canvas.toDataURL(imageFile.type);  

                        const base64String = dataurl.replace('data:', '').replace(/^.+,/, '');                      

                        var data ={
                            workorderId: me.workorderId,
                            lineId: me.lineId,
                            "assembleStepId":  me.assembleStepId,
                        };

                        //almacenamos datos imagen
                        api.postPicture(
                            data.workorderId,
                            data.lineId,
                            data,
                            function () {
                                data.image = base64String;

                                //planificamos subida binario imagen
                                pictureManager.addPicture(data);
                                me.$emit('pic-uploaded');
                            },
                            function (error) {
                                window.$vue.$log.error(error);

                                data.image = base64String;

                                //planificamos subida binario imagen
                                pictureManager.addPicture(data);                                    
                            }
                        );
                    }

                    img.src = e.target.result;

                    //img.src="data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAHElEQVQI12P4//8/w38GIAXDIBKE0DHxgljNBAAO9TXL0Y4OHwAAAABJRU5ErkJggg==";
                                                                
                };
                reader.readAsDataURL(imageFile); 
            }

      },
      onUploaderClick(){
        window.addEventListener('focus', () => {
            this.isSelecting = false;
        }, { once: true })
        this.$refs.uploader.click()
      },
      },
      mounted: function() {
        window.$vue.$off('connection:type');
        window.$vue.$on('connection:type', pictureManager.processNetworkUpdate);
        window.$vue.$off('ne_awake');
        window.$vue.$on('ne_awake', pictureManager.processAwake);
   },
  }
</script>